const Style = {

  base: 'max-w-25%' 

}

export default Style;